export default __webpack_public_path__ + "static/media/fav.cbe41223.ico";